module.exports = __webpack_public_path__ + "img/chevronDownDark.2996d899.svg";